import { ActivityAttendeeCountService } from './activity-attendee-count-service';

let activityAttendeeCountService: null | ActivityAttendeeCountService = null;

const getActivityAttendeeCountService = (): ActivityAttendeeCountService => {
  if(activityAttendeeCountService === null) {
    activityAttendeeCountService = new ActivityAttendeeCountService();
  }

  return activityAttendeeCountService;
};

export { getActivityAttendeeCountService };